import { IPaginationParams } from 'APIPackage/MainModule/interfaces/IPaginationParams';

export const createPaginationParams = ({ filter, ...rest }: IPaginationParams) => {
  const urlSearchParams = new URLSearchParams();

  Object.keys(rest).forEach((key: Extract<keyof typeof rest, string>) => {
    const value = rest[key];

    if (value) {
      urlSearchParams.append(key, value);
    }
  });
  if (filter) {
    filter.forEach(filterValue => urlSearchParams.append('filter', filterValue));
  }

  return urlSearchParams;
};
